import { APIService } from "./APIService";

export const AppAnnouncementsData = ({
    appId,
    pageFilters = {},
}) => {
    const baseEndpoint = `/app/announcements/?app_id=${encodeURIComponent(appId)}`;

    const filtersQuery = Object.entries(pageFilters)
        .filter(([_, value]) => value !== null && value !== undefined && value !== "")
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");

    const endpoint = `${baseEndpoint}${filtersQuery ? `&${filtersQuery}` : ""}`;

    return APIService({
        endpoint,
        method: "GET",
    });
};
